import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getDashboardAnalytics } from '../../services/api';

const Finance = () => {
    const userId = localStorage.getItem('userId');

    const { data, isLoading } = useQuery({
        queryKey: ['finance-analytics', userId],
        queryFn: () => getDashboardAnalytics(userId)
    });

    const analytics = data?.analytics || { totalRevenue: 0 };

    return (
        <div className="space-y-6 animate-fade-in">
            <div>
                <h1 className="text-2xl sm:text-3xl font-black text-gray-900 mb-1 sm:mb-2">Control Financiero</h1>
                <p className="text-gray-500 text-sm sm:text-base">Consulta tus ingresos, comisiones y pagos pendientes.</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
                <div className="bg-emerald-500 text-white p-6 sm:p-8 lg:p-10 rounded-2xl lg:rounded-[2.5rem] shadow-xl shadow-emerald-500/20">
                    <p className="text-[10px] sm:text-xs font-black uppercase tracking-[0.15em] sm:tracking-[0.2em] opacity-80 mb-2 sm:mb-4">Ingresos Totales</p>
                    <div className="text-3xl sm:text-4xl lg:text-5xl font-black">{isLoading ? '...' : `${analytics.totalRevenue}€`}</div>
                    <p className="mt-4 sm:mt-6 text-xs sm:text-sm font-bold opacity-70">Recaudación acumulada de todos tus pozos</p>
                </div>

                <div className="bg-white p-6 sm:p-8 lg:p-10 rounded-2xl lg:rounded-[2.5rem] border border-gray-100 shadow-sm">
                    <p className="text-[10px] sm:text-xs font-black uppercase tracking-[0.15em] sm:tracking-[0.2em] text-gray-400 mb-2 sm:mb-4">Comisiones (5%)</p>
                    <div className="text-3xl sm:text-4xl lg:text-5xl font-black text-gray-900">{isLoading ? '...' : `${(analytics.totalRevenue * 0.05).toFixed(2)}€`}</div>
                    <p className="mt-4 sm:mt-6 text-xs sm:text-sm font-bold text-gray-400">Deducido automáticamente</p>
                </div>

                <div className="bg-slate-900 text-white p-6 sm:p-8 lg:p-10 rounded-2xl lg:rounded-[2.5rem] shadow-2xl sm:col-span-2 lg:col-span-1">
                    <p className="text-[10px] sm:text-xs font-black uppercase tracking-[0.15em] sm:tracking-[0.2em] opacity-60 mb-2 sm:mb-4">Neto a Cobrar</p>
                    <div className="text-3xl sm:text-4xl lg:text-5xl font-black text-primary-400">{isLoading ? '...' : `${(analytics.totalRevenue * 0.95).toFixed(2)}€`}</div>
                    <button className="mt-6 sm:mt-8 w-full py-3 sm:py-4 bg-primary-500 hover:bg-primary-400 text-slate-950 font-black rounded-xl sm:rounded-2xl transition-all uppercase tracking-widest text-[10px] sm:text-xs">
                        Solicitar Transferencia
                    </button>
                </div>
            </div>

            <div className="bg-white rounded-2xl lg:rounded-[2.5rem] border border-gray-100 shadow-sm p-6 sm:p-8 lg:p-10">
                <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-6 sm:mb-8">Historial de Liquidaciones</h2>
                <div className="text-center py-12 sm:py-20 text-gray-400">
                    <div className="text-3xl sm:text-4xl mb-3 sm:mb-4">📑</div>
                    <p className="font-bold text-sm sm:text-base">No hay liquidaciones cerradas actualmente.</p>
                    <p className="text-xs sm:text-sm mt-1">Las liquidaciones se generan al finalizar cada mes natural.</p>
                </div>
            </div>
        </div>
    );
};

export default Finance;
